// These are duplicates of colors imports -
// Not bringing in colors to reduce dependency on theme
// These values are enforced via unit tests
const DN30 = '#1B2638';
const N0 = '#FFFFFF';
const themedBackground = {
  light: N0,
  dark: DN30
};
export const getBackground = (mode = 'light') => themedBackground[mode];